// @ts-nocheck
import buttonSizeVariants from "@insite/mobius/Button/buttonSizeVariants";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";

/** buttonSizeVariants
 * ------------------------------------------------------------------------------------------
 * height: Height applied as "min-height" (px)
 * fontSize: Font size (px)
 * padding: CSS applied to the padding property "padding: [VALUE];"
 * icon: Icon size (px)
 * iconPadding: Spacing between the icon and the text (px)
 */

Object.assign(buttonSizeVariants, {
    /* Store Custom Code - Start */
    small: {
        height: 30,
        fontSize: 14,
        padding: pxToRem(4, 20),
        icon: 20,
        iconPadding: 4,
    },
    medium: {
        height: 40,
        fontSize: 14,
        padding: pxToRem(8, 20),
        icon: 20,
        iconPadding: 4,
    },
    large: {
        height: 52,
        fontSize: 18,
        padding: pxToRem(12, 30),
        icon: 20,
        iconPadding: 4,
    },
    xlarge: {
        height: 52,
        fontSize: 18,
        padding: pxToRem(12, 30),
        icon: 20,
        iconPadding: 4,
    },
    /* Store Custom Code - End */
});
